export interface GlossDab {
  readonly x: number;
  readonly y: number;
  readonly z: number;
  readonly radius: number;
}

export function pointIsGloss(
  x: number,
  y: number,
  z: number,
  dabs: readonly GlossDab[],
): boolean {
  for (const dab of dabs) {
    const dx = x - dab.x;
    const dy = y - dab.y;
    const dz = z - dab.z;
    if (dx * dx + dy * dy + dz * dz <= dab.radius * dab.radius) return true;
  }
  return false;
}
